import { Button } from "@shared/ui/button";
import { Tabs } from "@shared/ui/tabs"; // Using the URL-based tab service
import { ArrowLeft, ChevronLeft, Info } from "lucide-react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { ConsumerTable } from "./ConsumerTable";
import { PaperBillDistribution } from "./PaperBillDistribution";
import { useNavigate } from "react-router-dom";

import { PageHeader } from "@shared/components/PageHeader";

export function ConsumerDistributionView() {
  const navigate = useNavigate();
  const [selectedMetric, setSelectedMetric] = useState<string | null>(null);
  const { cycleId } = useParams<{ cycleId: string }>();
  const tabComponents = {
    "consumer-list": {
      label: "Consumer List",
      component: (
        <>
          <ConsumerTable activeFilter={selectedMetric} />
        </>
      ),
    },
    "paper-distribution": {
      label: "Paper Bill Distribution",
      component: <PaperBillDistribution cycleId={cycleId || ""} />,
    },
  };

  return (
    <div className="space-y-6">
      <PageHeader
        title="Printing & Distribution Dashboard"
        subtitle="Manage print jobs and distribution across all channels"
        icon={ArrowLeft}
        onIconClick={() => navigate("/bx/printing-distribution?tab=distribution")}
      />

      <Tabs
        defaultValue="consumer-list"
        tabComponents={tabComponents}
        className="w-full"
        tabsListClassName="grid w-full grid-cols-2 mb-6 p-1"
        idPrefix="consumer-distribution"
        level={1}
      />
    </div>
  );
}
